import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientsSearchComponent } from './clients-search/clients-search.component';
import { ClientsFormComponent } from './clients-form/clients-form.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CreateEditVersionDialogComponent } from './clients-form/create-edit-version-dialog/create-edit-version-dialog.component';
import { ClientsVersionsFormComponent } from './clients-form/clients-form-versions/clients-versions-form.component';
import { ButtonCopyFieldComponent } from './clients-form/button-copy-field/button-copy-field.component';
import { CopyVersionDialogComponent } from './clients-form/copy-version-dialog/copy-version-dialog.component';
import { DomainsActivationFormComponent } from './clients-form/domains-activation-form/domains-activation-form.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ServiceManagementComponent } from './clients-form/service-management/service-management.component';
import { ServiceManagementRowComponent } from './clients-form/service-management/service-management-row/service-management-row.component';

@NgModule({
  declarations: [
    ClientsSearchComponent,
    ClientsFormComponent,
    ClientsVersionsFormComponent,
    ButtonCopyFieldComponent,
    CreateEditVersionDialogComponent,
    CopyVersionDialogComponent,
    DomainsActivationFormComponent,
    ServiceManagementComponent,
    ServiceManagementRowComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    DragDropModule,
    RouterModule.forChild([
      { path: 'search', component: ClientsSearchComponent },
      { path: 'edit/:clientFid', component: ClientsFormComponent },
      { path: 'new', component: ClientsFormComponent },
    ]),
  ],
})
export class ClientsModule {}
